import axios, { AxiosResponse } from 'axios';
import UseCommonService from '../commonService/commonService';
import type { LoaderContextType } from '../../components/loader/loader';

const httpService = axios.create({
  // baseURL: 'http://54.219.69.34:8001',
  // baseURL: "https://api.awahe.com/",
  baseURL:"https://api2.awahe.com/", // live api
  // baseURL: "http://localhost:8001"  // for local testing
  
});


httpService.interceptors.request.use((config) => {
  const commonService = UseCommonService();
  const token = commonService.getToken();
  if (token) {
    config.headers.Authorization = `${token}`;
  }
  return config;
});

interface VideoData {
  video: File;
}

interface ImageData {
  image: File;
  video: File;
  logo: File;
  file: File;
}


const uploadVideo = async (url: string, data: VideoData ,loaderContext?:LoaderContextType): Promise<any> => {

  if(loaderContext){
    loaderContext.show()
  }
  try {
    const formData = new FormData();
    formData.append('video', data.video);
    const response: AxiosResponse<any> = await httpService.post(url, formData);
    if(loaderContext){
      loaderContext.hide()
    }
    return response.data;
  } catch (error) {
    // if(loaderContext){
    //   loaderContext.show()
    // }
    console.error('Error uploading video:', error);
    throw error;
  }
};


const uploadImage1 = async (
  url: string,
  data: File,
  loaderContext?: LoaderContextType

): Promise<any> => {
  if (loaderContext) {
    loaderContext.show();


  }

  try {

    const formData = new FormData();
    formData.append("file", data);

    const response: AxiosResponse<any> = await httpService.post(url, formData);

    if (loaderContext) {
      loaderContext.hide();
    }
    return response.data;
  } catch (error) {
    if (loaderContext) {
      loaderContext.hide();
    }
    throw error;
  }
};

const uploadImage = async (
  url: string,
  data: any,
  loaderContext?: LoaderContextType
): Promise<any> => {
  if (loaderContext) {
    loaderContext.show();
  }

  try {
    console.log(data, "datadatadatadatammmmmmmmmmm");
    const formData = new FormData();
    formData.append("file", data.image);

    
    const response: AxiosResponse<any> = await httpService.post(url, formData);

    if (loaderContext) {
      loaderContext.hide();
    }
    return response.data;
  } catch (error) {
    // if (loaderContext) {
    //   loaderContext.show();
    // }
    console.error("Error uploading video:", error);
    // throw error;
  }
};




const uploadvideo = async (
  url: string,
  data: any,
  loaderContext?: LoaderContextType
): Promise<any> => {
  if (loaderContext) {
    loaderContext.show();
  }

  try {
    console.log(data, "datadatadatadatammmmmmmmmmm");
    const formData = new FormData();
    formData.append("file", data.video);

    
    const response: AxiosResponse<any> = await httpService.post(url, formData);

    if (loaderContext) {
      loaderContext.hide();
    }
    return response.data;
  } catch (error) {
    // if (loaderContext) {
    //   loaderContext.show();
    // }
    console.error("Error uploading video:", error);
    // throw error;
  }
};

// const uploadvideo = async (url: string, data: ImageData ,loaderContext?:LoaderContextType): Promise<any> => {
 
//   if(loaderContext){
//     loaderContext.show()
//   }
 
//   try {
//     const formData = new FormData();
//     formData.append('video', data.video);
//     const response: AxiosResponse<any> = await httpService.post(url, formData);
    
//   if(loaderContext){
//     loaderContext.hide()
//   }
//     return response.data;
//   } catch (error) {
//     // if(loaderContext){
//     //   loaderContext.show()
//     // }
//     console.error('Error uploading image:', error);
//     throw error;
//   }
// };



const uploadlogo = async (url: string, data: ImageData, loaderContext?: LoaderContextType): Promise<any> => {
  if (loaderContext) {
    loaderContext.show();
  }
  
  try {
    const formData = new FormData();
    formData.append('image', data.image); // Include the filename and set the content type
    
    const response: AxiosResponse<any> = await httpService.post(url, formData);
    
    if (loaderContext) {
      loaderContext.hide();
    }
    
    return response.data;
  } catch (error) {
    // if (loaderContext) {
    //   loaderContext.show();
    // }
    
    console.error('Error uploading image:', error);
    throw error;
  }
};





const getData = async (url: string, params?: any , loaderContext?: LoaderContextType): Promise<any> => {
  if (loaderContext) {
    loaderContext.show(); 
  }   
   try {
    const response: AxiosResponse<any> = await httpService.get(url, { params });
    if (loaderContext) {
      loaderContext.hide(); 
    }    return response.data;
  } catch (error) {
    // if(loaderContext){
    //   loaderContext.show()
    // }  console.error('Error fetching data:', error);
    throw error;
  }
};

const putData = async (url: string, data: any, formData = false ,loaderContext?:LoaderContextType) => {
 if(loaderContext){
  loaderContext.show()
 }
 
  try {
    const postData = formData ? appendFormData(data) : data;  
    const response: AxiosResponse<any> = await httpService.put(url, postData);
    if(loaderContext){
      loaderContext.hide()
     }
    return response.data;
  } catch (error) {
    // if(loaderContext){
    //   loaderContext.show()
    //  }
    console.error('Error putting data:', error);
    throw error;
  }
};





const postData = async (url: string, data: any, loaderContext?: LoaderContextType): Promise<any> => {
  try {
    if (loaderContext) {
      loaderContext.show();
    }
    const response: AxiosResponse<any> = await httpService.post(url, data);
    if (loaderContext) {
      loaderContext.hide();
    }
    return response.data;
  } catch (error) {
    // if (loaderContext) {
    //   loaderContext.hide();
    // }
    console.error('Error posting data:', error);
    throw error;
  }
};


const deleteData = async (url: string,  loaderContext?: LoaderContextType): Promise<any> => {
  try {
    if (loaderContext) {
      loaderContext.show();
    }
    const response: AxiosResponse<any> = await httpService.delete(url);
    if (loaderContext) {
      loaderContext.hide();
    }
    return response.data;
  } catch (error) {
    // if (loaderContext) {
    //   loaderContext.hide();
    // }
    console.error('Error posting data:', error);
    throw error;
  }
};

// const postData = async (url: string, data: any, formData?: boolean ,loaderContext?:LoaderContextType): Promise<any> => {
//   try {
//     if(loaderContext){
//       loaderContext.show() 
//     }
//     const postData = formData ? appendFormData(data) : data;
//     const response: AxiosResponse<any> = await httpService.post(url, postData);
//     if(loaderContext){
//       loaderContext.hide() 
//     }
//     return response.data;
//   } catch (error) {
//     if(loaderContext){
//       loaderContext.show() 
//     }
//     console.error('Error posting data:', error);
//     throw error;
//   }
// };


const appendFormData = (myFormData: any): FormData => {
  const fd = new FormData();
  for (const key of Object.keys(myFormData)) {
    fd.append(key, myFormData[key]);
  }
  return fd;
};



const uploadpdf = async (
  url: string,
  data: any,
  loaderContext?: LoaderContextType
): Promise<any> => {
  console.log("ImageData", data);
  if (loaderContext) {
    loaderContext.show();
  }

  try {
    const formData = new FormData();
    formData.append("file", data);
    const response: AxiosResponse<any> = await httpService.post(url, formData);

    if (loaderContext) {
      loaderContext.hide();
    }
    return response.data;
  } catch (error) {
    if (loaderContext) {
      loaderContext.show();
    }
    console.error("Error uploading video:", error);
    // throw error;
  }
};


const uploadpdfd = async (
  url: string,
  data: any,
  loaderContext?: LoaderContextType
): Promise<any> => {
  if (loaderContext) {
    loaderContext.show();
  }
console.log(data,"datadatadatadatadata")
  try {
    const response: AxiosResponse<any> = await httpService.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (loaderContext) {
      loaderContext.hide();
    }
    return response.data;
  } catch (error) {
    if (loaderContext) {
      loaderContext.hide();
    }
    console.error('Error uploading file:', error);
    throw error;
  }
};



const uploadpdr = async (
  url: string,
  data: any,
  loaderContext?: LoaderContextType
): Promise<any> => {
  console.log("Data to upload:",(data)); // Log the data

  if (loaderContext) {
    loaderContext.show();
  }

  try {
    // Prepare FormData with JSON data
    const formData = new FormData();
    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
    console.log(blob,"blobblobblob")
    formData.append("file", blob, "data.json");

    // Post the data to the server
    const response: AxiosResponse<any> = await httpService.post(url, formData);

    if (loaderContext) {
      loaderContext.hide();
    }

    return response.data;
  } catch (error) {
    if (loaderContext) {
      loaderContext.hide();
    }
    console.error("Error uploading data:", error);
    throw error; // Optional: rethrow the error for further handling
  }
};

export {uploadpdr, uploadVideo, uploadImage, uploadImage1, getData, postData, putData, uploadlogo, uploadvideo, httpService ,uploadpdf,uploadpdfd , deleteData };

// DSDDSSD